import React from "react";
import Logo from "./logo";

const Header = (props) => {
  const content = props.content || null;

  return (
    <div className="header-section">
      <Logo />
      {content && (
        <div className="access-title">
          <h1>{content}</h1>
        </div>
      )}
    </div>
  );
};

export default Header;
